export default {
  loginError: 'Please login angin.',
  noPermission: 'No permission.',
  '服务端接口连接超时，请检查您当前的网络状态': 'The server connection timed out, please check your network.',
  '请求错误，请稍后再试': 'Request Error, please try again later',
  '服务端接口异常，请与平台客服沟通': 'The server interface is abnormal. Please contact platform client service',
  '数据加载失败，请检查您的浏览器版本或刷新本页面':
    'Loading failed, please check your browser version or refresh this page',
  系统错误请联系管理员: 'System error.',
  修改成功: 'Modified successfully'
};
